<template>
    <div>

        <div style="display:none;">startprint</div>
        <div v-if="!pbbfdata.bdflag" style="text-align:center;">
            <h4 style="font-size:24px;margin-bottom:15px;">{{pbbfdata.zbfilename}}</h4>
            <div style="font-size:20px;margin-bottom:15px;font-weight:bold;" v-for="(item,index) in pbbfdata.bdlist" :key="index">相关标段：{{item.bdname}}</div>
        </div>
        <div v-if="pbbfdata.bdflag" style="text-align:center;">
            <h4 style="font-size:20px;margin-bottom:15px;font-weight:bold;">标段名称:{{pbbfdata.bdname}}</h4>
        </div>
        <div class="detail">
            <ul>
                <li v-for="(item,index) in pbbfdata.listPfNode" :key="index">
                    <h4 style="font-size:20px;margin-bottom:15px;font-weight:bold;color:#394046;margin:12px 0;">
                        <span>{{index+1}}:{{item.nodecaption}}</span>
                        <a @click="clearbidDetail" v-if="item.nodecaption == '清标'">清标详细参数</a>
                        <span v-if="item.nodecaption == 'YesOrNo'">（符合性）</span>
                        <span v-if="item.nodecaption == 'Range'">（范围）</span>
                        <span v-if="item.nodecaption == 'BasePrice'">（计算基准价）</span>
                        <span v-if="item.nodecaption == 'Offer'">（报价打分）</span>
                        <span v-if="item.nodecaption == 'Candidate'">（候选人）</span>
                        <span v-if="item.nodecaption == 'Report'">（评标报告）</span>
                    </h4>
                    <div v-if="item.nodetype != 'Offer' && item.nodetype != 'BasePrice'">
                        <p v-for="(j,indexIn) in item.listPfd" :key="indexIn">
                            <span>（{{indexIn+1}}）{{j.nodecaption}}:</span>
                            <span>{{j.standard}}</span>
                            <span v-if="j.reasonrequire=='true'">
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <font color="red">该项评委扣分必须说明理由</font>
                            </span>
                        </p>
                    </div>
                    <div v-if="item.nodetype == 'Range'">
                        <p>
                            <span>{{item.nodemaxmin}}</span>
                        </p>
                    </div>
                    <div v-if="item.nodetype == 'Offer' || item.nodetype == 'BasePrice' || item.nodetype == 'Candidate'">
                        <p>
                            <span v-html="item.auditoption"></span>
                        </p>
                    </div>
                    <div v-if="item.nodetype != 'Offer' && item.nodetype != 'BasePrice'">
                        <p>
                            <span>
                                {{item.nodeweights}}
                            </span>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <div style="display:none;">endprint</div>
        <div style="text-align:center;margin-top:40px;">
            <el-button type="primary" @click="print" id="print">打印评标办法</el-button>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="70%">
            <el-tabs v-model="activeName">
                <el-tab-pane label="规费" name="first">
                    <table v-if="pbbfdata.clearbid" class="table">
                        <tr>
                            <th>专业</th>
                            <td>费率</td>
                        </tr>
                        <tr v-for="(x,index) in pbbfdata.clearbid_gf" :key="index">
                            <th>{{x.pname}}</th>
                            <td>{{x.pvalue}}</td>
                        </tr>
                    </table>
                </el-tab-pane>
                <el-tab-pane label="税金" name="second">
                    <table v-if="pbbfdata.clearbid" class="table">
                        <tr v-for="(x,index) in pbbfdata.clearbid_sj" :key="index">
                            <th>{{x.pname}}</th>
                            <td>{{x.pvalue}}</td>
                        </tr>
                    </table>
                </el-tab-pane>
                <el-tab-pane label="安全生产文明施工费" name="third">
                    <table v-if="pbbfdata.clearbid" class="table">
                        <tr>
                            <th>专业</th>
                            <td>费率</td>
                        </tr>
                        <tr v-for="(x,index) in pbbfdata.clearbid_sgf" :key="index">
                            <th>{{x.pname}}</th>
                            <td>{{x.pvalue}}</td>
                        </tr>
                    </table>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        
    </div>
</template>

<script>

export default {
    data() {
        return{
            PtXxk:"",
            back:"",
            pbbfdata:{},
            activeName:"first",
            dialogVisible:false,
        }
    },
    methods:{
        print(){
            var bdhtml=window.document.body.innerHTML; //获取当前页的html代码
            var sprnstr="startprint"; //设置打印开始区域
            var eprnstr="endprint";  //设置打印结束区域
            
            //var prnhtml=bdhtml.substr(bdhtml.indexOf(sprnstr)+17);  //从开始代码向后取html
            var prnhtml=bdhtml.substring(0,bdhtml.indexOf(eprnstr));  //从结束代码向前取html
            window.document.body.innerHTML=prnhtml;
            window.print();
            window.document.body.innerHTML=bdhtml;    //还原页面
            var that = this;
            this.$nextTick(function(){
                $('#print').click(function(){
                    that.print();
                })
            })
        },
        clearbidDetail(){
            this.dialogVisible = true;
        },
        getJspData:function(){
            var that = this;
            $.get(`${that.getGetters('bidUrl')}/FaBiao/ZbFile/Pbbf/pbbfdetail.json?procode=${that.getQuery('procode')}&zbfilecode=${that.getQuery('zbfilecode')}`,function(data){
                that.pbbfdata = data.t;
            })
        }
    },
    created(){
       
    },
    mounted(){
        this.getJspData();
    }
}
</script>

<style>

</style>